import * as React from "react";
import { NotifyContext } from "../managers/NotifyManager";

function useNotify() {
  return React.useContext(NotifyContext).notify;
}

export default useNotify;
